import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import './AuthPage.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo"><img src="/logo.png" alt="The Daily Bid" style={{ height: 75 }} /></div>
        <p className="auth-sub">Reset your password</p>
        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <p>If this email is registered, you will receive a reset link shortly.</p>
            <p className="auth-footer"><Link to="/login">Back to login</Link></p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            {error && <div className="error-msg">{error}</div>}
            <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%', marginTop: 16 }}>
              {loading ? <span className="spinner" /> : 'Send reset link'}
            </button>
            <p className="auth-footer"><Link to="/login">Back to login</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
